import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
const React = require("react");
import { classNamesConfig } from "../features/classnames";
export const Pager = (props)=>{
    const { currentPage, setPage, pageSize, totalResults } = props;
    const maxPageLinks = props.maxPageLinks || 4;
    const includeContainer = props.includeContainer !== false;
    const lastPage = Math.ceil(totalResults / pageSize);
    if (lastPage <= 1) return /*#__PURE__*/ _jsx(_Fragment, {});
    const pagesBracket = Math.floor(maxPageLinks / 2);
    const active = (page)=>1 <= page && page <= lastPage;
    const prevPage = currentPage - 1;
    const nextPage = currentPage + 1;
    const classNames = classNamesConfig().pager;
    let navArray = [];
    if (lastPage <= maxPageLinks) {
        Array.from({
            length: lastPage
        }, (_, i)=>i + 1).forEach((i)=>navArray.push([
                i,
                i.toString(),
                active(i),
                i == lastPage ? 'last number' : 'number'
            ]));
    } else {
        // First link should never be below 1, and never over lastPage - maxPages
        const first = Math.min(Math.max(1, currentPage - pagesBracket), lastPage - maxPageLinks + 1);
        const last = first + maxPageLinks - 1;
        if (first > 1) navArray.push([
            1,
            '1',
            active(1),
            'first number'
        ]); // If the first page falls outside the maxPages range, add it explicitly
        if (first > 2) navArray.push([
            null,
            ellipses,
            false,
            'ellipsis'
        ]); // If the first link in the pager is 3 or higher, add ellipses
        Array.from({
            length: maxPageLinks
        }, (_, i)=>first + i).forEach((i)=>navArray.push([
                i,
                i.toString(),
                active(i),
                i == lastPage ? 'last number' : 'number'
            ]));
        if (last < lastPage - 1) navArray.push([
            null,
            ellipses,
            false,
            'ellipsis'
        ]); // Add ellipses if last page in range is more than 1 removed from actual last page
        if (last < lastPage) navArray.push([
            lastPage,
            lastPage.toString(),
            active(lastPage),
            'last number'
        ]); // Add last page if not in range
    }
    return /*#__PURE__*/ _jsxs("div", {
        className: `pager ${includeContainer ? `container--${props.containerSize ? props.containerSize : 'mg'} align--center` : ''}`,
        children: [
            /*#__PURE__*/ _jsx("button", {
                disabled: prevPage == 0 ? true : null,
                className: `pager__prev ${classNames.navigationButton}`,
                onClick: (e)=>{
                    setPage(prevPage);
                },
                children: "Vorige"
            }),
            /*#__PURE__*/ _jsxs("span", {
                className: "pager__status pager__active",
                "aria-hidden": "true",
                children: [
                    currentPage,
                    " / ",
                    lastPage
                ]
            }),
            /*#__PURE__*/ _jsx("ul", {
                className: "pager__list",
                children: navArray.map((param, i)=>{
                    let [page, label, active, extraClasses] = param;
                    return extraClasses == 'ellipsis' ? /*#__PURE__*/ _jsx("li", {
                        className: `pager__item ${extraClasses ? extraClasses : ''}`,
                        children: /*#__PURE__*/ _jsx("span", {
                            className: "pager__active",
                            children: label
                        })
                    }, 'page-' + label + i + extraClasses) : page != currentPage ? /*#__PURE__*/ _jsx("li", {
                        className: `pager__item ${extraClasses ? extraClasses : ''}`,
                        children: /*#__PURE__*/ _jsx("button", {
                            className: "pager__link link link--primary",
                            onClick: (e)=>{
                                setPage(page);
                            },
                            children: label
                        })
                    }, 'page-' + label + i + extraClasses) : /*#__PURE__*/ _jsx("li", {
                        className: `pager__item ${page == currentPage ? 'pager__item--active' : ''} ${extraClasses ? extraClasses : ''}`,
                        children: /*#__PURE__*/ _jsx("span", {
                            className: "pager__active",
                            children: label
                        })
                    }, 'page-' + label + i);
                })
            }),
            /*#__PURE__*/ _jsx("button", {
                disabled: nextPage > lastPage ? true : null,
                className: `pager__next ${classNames.navigationButton}`,
                onClick: (e)=>{
                    setPage(nextPage);
                },
                children: "Volgende"
            })
        ]
    });
};
const ellipses = '\u2026';
